module.exports = __webpack_public_path__ + "static/media/6.HTP.cc9d3745.jpg";